import { Component } from '@angular/core';
import {NavBarComponent} from "../nav-bar/nav-bar.component";
import {TopBarComponent} from "../../top-bar/top-bar.component";
import {FooterPersonaComponent} from "../footer-persona/footer-persona.component";
import {HeroOnLinkComponent} from "./hero-on-link/hero-on-link.component";
import {HeroMoviLinkComponent} from "../movi-link/hero-pages/hero-movi-link.component";
import {ServicesOnLinkComponent} from "./services-on-link/services-on-link.component";
import {HowToApplyServiceComponent} from "../movi-link/how-to-apply-service/how-to-apply-service.component";
import {InfoMedicoComponent} from "./info-medico/info-medico.component";
import {FloatButtonComponent} from "../../float-button/float-button.component";

@Component({
  selector: 'app-on-link',
  standalone: true,
  imports: [
    NavBarComponent,
    TopBarComponent,
    FooterPersonaComponent,
    HeroOnLinkComponent,
    HeroMoviLinkComponent,
    ServicesOnLinkComponent,
    HowToApplyServiceComponent,
    InfoMedicoComponent,
    FloatButtonComponent
  ],
  templateUrl: 'on-link.component.html',
  styleUrl: './on-link.component.css'
})
export class OnLinkComponent {



}
